var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":"inside"}},[_c('h1',[_vm._v("Witaj "+_vm._s(_vm.user.fullname.split(' ')[0])+",")]),_c('div',{staticClass:"list"},[_c('ToHoliday'),_c('Holidays')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }